import React, { PropsWithChildren } from "react";

interface Props {
  label: string;
  isRequired?: boolean;
}

const LabeledFormControl: React.FC<Props & PropsWithChildren> = ({
  label,
  isRequired,
  children,
}): React.ReactElement => {
  return (
    <div>
      <label className="font-semibold">
        {label} {isRequired && <span className="text-error">*</span>}
      </label>
      <div className="mt-1">{children}</div>
    </div>
  );
};

export default LabeledFormControl;
